export const cardStyles = {
  base: `
    bg-white dark:bg-slate-800/70
    rounded-xl
    border border-slate-200 dark:border-slate-700/50
    transition-all duration-200
    shadow-card
  `,

  variants: {
    default: '',

    glass: `
      bg-white/70 dark:bg-slate-800/40
      backdrop-blur-lg
      border-white/20 dark:border-slate-700/30
    `,

    gradient: `
      bg-gradient-to-br from-primary-50 to-white
      dark:from-primary-900/20 dark:to-slate-800
      border-primary-100 dark:border-primary-800/30
    `,

    elevated: `
      shadow-card-hover
    `,

    outlined: `
      shadow-none
      border-2 border-slate-200 dark:border-slate-700
    `,
  },

  padding: {
    none: 'p-0',
    sm:   'p-3',
    md:   'p-5',
    lg:   'p-7',
  },

  hoverable: `
    hover:shadow-card-hover
    hover:-translate-y-0.5
    cursor-pointer
  `,
};
